import {
  FETCH_CURRENCIES_CROSS_RATES_REQUEST,
  FETCH_CURRENCIES_CROSS_RATES_SUCCESS,
  FETCH_CURRENCIES_CROSS_RATES_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {};

export const currenciesCrossRates = createReducer(initialState, {
  [FETCH_CURRENCIES_CROSS_RATES_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.requestKey]: {
      ...(state[action.payload.requestKey] || {}),
      isFetching: true,
      isRequestFailed: false,
      isLoaded: false,
    },
  }),

  [FETCH_CURRENCIES_CROSS_RATES_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.requestKey]: {
      ...state[action.payload.requestKey],
      rates: action.payload.data.rates,
      isFetching: false,
      isRequestFailed: false,
      isLoaded: true,
    },
  }),

  [FETCH_CURRENCIES_CROSS_RATES_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.requestKey]: {
      ...(state[action.payload.requestKey] || {}),
      isFetching: false,
      isRequestFailed: true,
      isLoaded: false,
    },
  }),
});

export default currenciesCrossRates;
